import { Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';
import { MENU_ITEM_STYLE } from '../menu.model';

export type EmptyStateItemProps = {
  children: ReactNode;
};

const useStyles = makeStyles()((theme) => ({
  root: {
    paddingTop: theme.spacing(MENU_ITEM_STYLE.PADDING_Y),
    paddingBottom: theme.spacing(MENU_ITEM_STYLE.PADDING_Y),
    paddingLeft: theme.spacing(MENU_ITEM_STYLE.PADDING_X),
    paddingRight: theme.spacing(MENU_ITEM_STYLE.PADDING_X),
    minHeight: MENU_ITEM_STYLE.MIN_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const EmptyStateItem: React.FC<EmptyStateItemProps> = ({ children }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        {children}
      </Typography>
    </div>
  );
};
